import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import cx from 'clsx';
import { useTheme } from '../../../ThemeProvider';
import Background from '../../../components/Background/Background';
import Highlight from '../../../components/Highlight/Highlight';
import { generateRawData, generateJsonData } from '../generator';
import classes from './Output.styles.less';
export default function Output({ type, fields, amount, seed = null }) {
    const [theme] = useTheme();
    const [rawData, setRawData] = useState(generateRawData());
    const [jsonData, setJsonData] = useState(generateJsonData(fields, amount));
    useEffect(() => {
        setRawData(generateRawData());
        setJsonData(generateJsonData(fields, amount));
    }, [seed]);
    if (type === 'default') {
        const items = rawData.map((item) => (_jsxs("div", { className: classes.rawItem, children: [_jsx("div", { className: classes.key, children: item.key }), _jsx("div", { className: classes.value, children: item.data })] }, item.key)));
        return _jsx(Background, { className: cx(classes.wrapper, classes[theme]), children: items });
    }
    return (_jsx(Background, { className: cx(classes.wrapper, classes[theme]), children: _jsx(Highlight, { children: JSON.stringify(jsonData, null, 2) }) }));
}
